import api from "./axiosInterceptor";

export const createScenario = (scenarioDetails) =>
  api.post("/scenario/api/scenarios", scenarioDetails);

export const fetchScenarios = () => api.get("/scenario/api/scenarios");

export const deleteScenario = (id) =>
  api.delete(`/scenario/api/scenarios/${id}`);

export const updateScenario = ({ id, updateData }) =>
  api.put(`/scenario/api/scenarios/${id}`, updateData);

export const fetchIndividualScenarios = (id) =>
  api.get(`/scenario/api/scenarios/${id}`);

export const generateMitigation = ({ id, postData }) =>
  api.post(`/scenario/api/${id}/mitigate`, postData);

export const updateUserProfile = (profileData) =>
  api.put("/accounts/api/user-profile", profileData);

export const updateMitigationStatus = ({ id, postData }) =>
  api.put(`/scenario/api/mitigation/${id}/execute/`, postData);

export const riskOpportunityDetails = (id) =>
  api.get(`scenario/api/scenario/${id}/riskopportunity`);

export const generateStrategy = ({ id, postData }) =>
  api.post(`scenario/api/scenarios/${id}/generate-strategies`, postData);

export const getStrategyData = (scenarioId, categoryId) =>
  api.get(
    `scenario/api/strategies/risk-opportunity/${scenarioId}/category/${categoryId}`
  );

export const executeStrategy = ({ id }) =>
  api.put(`/scenario/api/execute-strategy/${id}`, {});

export const fetchMarketNews = (page, size, news_type) =>
  api.get("/trends/api/trend/market-news", {
    params: { page, page_size: size, news_type },
  });

export const getMarketTrendsDetails = ({ articleId }) =>
  api.get(`/trends/api/trend/market-news?article_id=${articleId}`);
